<template>
  <div class="relative">
    <div v-if="length" class="flex">
      <div
        v-for="star in length"
        :key="star"
        class="flex items-center justify-center"
        :class="sizeClasses.container"
      >
        <UiIcon
          name="star_filled"
          class="text-[#F2F2F2]"
          :class="sizeClasses.icon"
        />
      </div>
    </div>
    <div v-if="ratingRender.startLength" class="absolute top-0 left-0 flex">
      <div
        v-for="star in ratingRender.startLength"
        :key="star"
        class="flex items-center justify-center"
        :class="sizeClasses.container"
      >
        <UiIcon
          name="star_filled"
          class="text-button-primary"
          :class="sizeClasses.icon"
        />
      </div>
      <div
        class="flex items-center justify-center"
        :class="sizeClasses.container"
      >
        <UiIcon
          v-if="ratingRender.lastStar"
          name="star_filled"
          class="text-button-primary"
          :class="sizeClasses.icon"
          :style="{
            clipPath: `inset(0
        ${ratingRender.lastStar}% 0 0)`,
          }"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
const props = withDefaults(
  defineProps<{ length?: number; rating: number; small?: boolean }>(),
  {
    length: 5,
  },
);

const sizeClasses = computed(() => {
  return props.small
    ? {
        container: "h-3 w-3",
        icon: "h-2.5 w-2.5",
      }
    : {
        container: "h-5 w-5",
        icon: "h-4 w-4",
      };
});

const ratingRender = computed(() => {
  const length = Math.min(props.length, Math.floor(Number(props.rating)));
  const rating = Math.min(props.length, Number(props.rating));

  return {
    startLength: length,
    lastStar: Math.trunc((1 - (Number(rating) % 1)) * 100),
  };
});
</script>
